export const yesNoOptions = [
    {label: "Yes", value: "yes"},
    {label: "No", value: "no"},
] as const

export const yesNoType = ["yes", "no"] as const 

export const ratingOptions = [1, 2, 3, 4, 5] as const;

export const yesNoUnknownOptions = [
    ...yesNoOptions,
    {label: "Unknown", value: "unknown"}
] as const

export const yesNoRejectedOptions = [
    ...yesNoOptions,
    {label: "Rejected", value: "rejected"}
] as const

export const homeOwnerAgeOptions = [
    {label: "25 - 35", value: "25 - 35"},
    {label: "36 - 45", value: "36 - 45"},
    {label: "46 - 55", value: "46 - 55"},
    {label: "56 - 65", value: "56 - 65"},
    {label: "66 - 75", value: "66 - 75"},
] as const

export const yesNoBooleanOptions = [
    {label: "Yes", value: "true"},
    {label: "No", value: "false"},
] as const